import {
  COMPANY_DETAIL_START,
  COMPANY_DETAIL_SUCCESS,
  COMPANY_DETAIL_FAIL,
  COMPANY_BRANCHES_START,
  COMPANY_BRANCHES_SUCCESS,
  COMPANY_BRANCHES_FAIL,
  DEPARTMENT_OF_BRANCH_START,
  DEPARTMENT_OF_BRANCH_SUCCESS,
  DEPARTMENT_OF_BRANCH_FAIL,
  UPDATE_BRANCH_START,
  UPDATE_BRANCH_SUCCESS,
  UPDATE_BRANCH_FAIL,
  CREATE_BRANCH_START,
  CREATE_BRANCH_SUCCESS,
  CREATE_BRANCH_FAIL,
  CREATE_DEPARTMENT_START,
  CREATE_DEPARTMENT_SUCCESS,
  CREATE_DEPARTMENT_FAIL,
  UPDATE_COMPANY_START,
  UPDATE_COMPANY_SUCCESS,
  UPDATE_COMPANY_FAIL,
  UPLOAD_COMPANY_LOGO_START,
  UPLOAD_COMPANY_LOGO_SUCCESS,
  UPLOAD_COMPANY_LOGO_FAIL,
  DELETE_BRANCH_START,
  DELETE_BRANCH_SUCCESS,
  DELETE_BRANCH_FAIL,
  DELETE_DEPARTMENT_START,
  DELETE_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT_FAIL,
  CREATE_COMPANY_START,
  CREATE_COMPANY_SUCCESS,
  CREATE_COMPANY_FAIL
} from './constants';

export const companyReducer = (
  state = {
    companyInfo: {},
    branches: [],
    fetching: false,
    error: null
  },
  action
) => {
  switch (action.type) {
    case COMPANY_DETAIL_START:
    case UPDATE_BRANCH_START:
    case CREATE_BRANCH_START:
    case CREATE_DEPARTMENT_START:
    case UPDATE_COMPANY_START:
    case UPLOAD_COMPANY_LOGO_START:
    case DELETE_DEPARTMENT_START:
    case DELETE_BRANCH_START:
    case CREATE_COMPANY_START:
      return { ...state, fetching: true };
    case COMPANY_DETAIL_SUCCESS:
    case CREATE_COMPANY_SUCCESS:
    case UPDATE_COMPANY_SUCCESS:
      return {
        ...state,
        fetching: false,
        companyInfo: { ...state.companyInfo, ...action.payload }
      };
    case UPLOAD_COMPANY_LOGO_SUCCESS:
      return {
        ...state,
        fetching: false,
        companyInfo: { ...state.companyInfo, logo: action.payload }
      };
    case COMPANY_DETAIL_FAIL:
      return { ...state, fetching: false, error: action.payload };
    case COMPANY_BRANCHES_START:
      return { ...state, fetching: true };
    case COMPANY_BRANCHES_SUCCESS:
      return { ...state, fetching: false, branches: action.payload };
    case COMPANY_BRANCHES_FAIL:
      return { ...state, fetching: false, error: action.payload };
    case UPDATE_BRANCH_SUCCESS:
      return { ...state, fetching: false };
    case UPDATE_BRANCH_FAIL:
      return { ...state, fetching: false, error: action.payload };
    case CREATE_BRANCH_SUCCESS:
      return { ...state, fetching: false, branches: [...state.branches, action.payload] };
    case CREATE_BRANCH_FAIL:
      return { ...state, fetching: false, error: action.payload };
    case DELETE_BRANCH_SUCCESS:
      return {
        ...state,
        fetching: false,
        branches: [
          ...state.branches.filter((item) => {
            if (item.id === action.payload) {
              return null;
            }
            return item;
          })
        ]
      };
    case DELETE_DEPARTMENT_FAIL:
    case DELETE_BRANCH_FAIL:
      return { ...state, fetching: false, error: action.payload };
    case DELETE_DEPARTMENT_SUCCESS:
      return {
        ...state,
        fetching: false,
        branches: [
          ...state.branches.map((item) => {
            if (item.id === action.payload.branchId) {
              return {
                ...item,
                departments: [
                  ...item.departments.filter((dep) => {
                    if (dep.id === action.payload.departmentId) {
                      return null;
                    }
                    return item;
                  })
                ]
              };
            }
            return item;
          })
        ]
      };
    case DEPARTMENT_OF_BRANCH_START:
      return { ...state, fetching: true };
    case CREATE_DEPARTMENT_SUCCESS:
      return {
        ...state,
        fetching: false,
        branches: [
          ...state.branches.map((item) => {
            if (item.id === action.payload.id) {
              return { ...item, departments: [...item.departments, action.payload.payload] };
            }
            return item;
          })
        ]
      };
    case DEPARTMENT_OF_BRANCH_SUCCESS:
      return {
        ...state,
        fetching: false,
        branches: [
          ...state.branches.map((item) => {
            if (item.id === action.branchId) {
              return { ...item, departments: action.payload };
            }
            return item;
          })
        ]
      };
    case CREATE_DEPARTMENT_FAIL:
    case UPDATE_COMPANY_FAIL:
    case DEPARTMENT_OF_BRANCH_FAIL:
    case UPLOAD_COMPANY_LOGO_FAIL:
    case CREATE_COMPANY_FAIL:
      return { ...state, fetching: false, error: action.payload };
    default:
      return state;
  }
};
UPDATE_BRANCH_SUCCESS, UPDATE_BRANCH_FAIL;
